(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comoseusa"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuvia-use')) {
    customElements.define('nuvia-use', class extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.reduce = reduce;

        /* ---------- Videos de fondo / marco: siempre mudos, solo el visible reproduce ---------- */
        this.bgVideos = Array.from(this.querySelectorAll('.nu-video'));
        this.bgVideos.forEach((v) => { v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); });
        this.syncVideos = () => {
          this.bgVideos.forEach((v) => {
            const visible = v.offsetParent !== null && getComputedStyle(v).display !== 'none' && this.heroVisible !== false;
            if (visible && !this.dialogOpen) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
            else v.pause();
          });
        };
        if ('IntersectionObserver' in window) {
          this.heroIo = new IntersectionObserver((e) => { this.heroVisible = e[0].isIntersecting; this.syncVideos(); }, { threshold: .05 });
          const hero = this.querySelector('.nuvia-use-hero');
          if (hero) this.heroIo.observe(hero);
        }
        this.mq = window.matchMedia('(min-width: 990px)');
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.syncVideos);
        this.syncVideos();

        /* ---------- Popup del tutorial ---------- */
        const dialog = this.querySelector('[data-video-dialog]');
        const dialogVideo = dialog ? dialog.querySelector('video') : null;
        if (dialog && dialogVideo) {
          this.querySelectorAll('[data-video-open]').forEach((button) => {
            button.addEventListener('click', () => {
              if (!dialog.open) dialog.showModal();
              this.dialogOpen = true;
              this.syncVideos();
              document.documentElement.style.overflow = 'hidden';
              dialogVideo.muted = false;
              const p = dialogVideo.play();
              if (p && p.catch) p.catch(() => {});
            });
          });
          const closeBtn = this.querySelector('[data-video-close]');
          if (closeBtn) closeBtn.addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
          dialog.addEventListener('close', () => {
            dialogVideo.pause();
            dialogVideo.currentTime = 0;
            this.dialogOpen = false;
            document.documentElement.style.overflow = '';
            this.syncVideos();
          });
        }

        /* ---------- Carrusel de recomendaciones ---------- */
        const track = this.querySelector('[data-carousel-track]');
        const prev = this.querySelector('[data-carousel-prev]');
        const next = this.querySelector('[data-carousel-next]');
        const bar = this.querySelector('[data-carousel-bar]');
        const current = this.querySelector('[data-carousel-current]');
        const cards = track ? Array.from(track.querySelectorAll('[data-carousel-card]')) : [];

        if (track && cards.length) {
          const step = () => cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0);
          const update = () => {
            const max = track.scrollWidth - track.clientWidth;
            const idx = Math.min(cards.length - 1, Math.round(track.scrollLeft / step()));
            cards.forEach((c, i) => c.classList.toggle('is-active', i === idx));
            if (current) current.textContent = String(idx + 1).padStart(2, '0');
            if (prev) prev.disabled = track.scrollLeft <= 2;
            if (next) next.disabled = track.scrollLeft >= max - 2;
            if (bar) {
              const visible = Math.min(1, track.clientWidth / track.scrollWidth);
              const pos = max > 0 ? track.scrollLeft / max : 0;
              bar.style.setProperty('--w', (visible * 100).toFixed(2) + '%');
              bar.style.setProperty('--l', (pos * (1 - visible) * 100).toFixed(2) + '%');
            }
          };
          const move = (dir) => track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
          if (prev) prev.addEventListener('click', () => move(-1));
          if (next) next.addEventListener('click', () => move(1));
          let ticking = false;
          track.addEventListener('scroll', () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; update(); }); }, { passive: true });
          window.addEventListener('resize', update);
          track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); move(1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); move(-1); }
          });
          cards.forEach((c, i) => c.addEventListener('mouseenter', () => cards.forEach((x, k) => x.classList.toggle('is-active', k === i))));
          track.addEventListener('mouseleave', update);

          /* arrastrar con el mouse */
          let down = false, sx = 0, sl = 0, moved = false;
          track.addEventListener('mousedown', (e) => { if (e.button !== 0) return; down = true; moved = false; sx = e.pageX; sl = track.scrollLeft; });
          window.addEventListener('mousemove', (e) => {
            if (!down) return;
            const dx = e.pageX - sx;
            if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
            if (moved) track.scrollLeft = sl - dx;
          });
          window.addEventListener('mouseup', () => {
            if (!down) return;
            down = false;
            if (moved) { track.classList.remove('is-drag'); track.scrollTo({ left: Math.round(track.scrollLeft / step()) * step(), behavior: 'smooth' }); }
          });
          update();
        }

        /* ---------- Entradas animadas ---------- */
        if (this.classList.contains('nuvia-use--animate') && !reduce && 'IntersectionObserver' in window) {
          this.classList.add('nu-ready');
          this.inIo = new IntersectionObserver((entries) => {
            entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); this.inIo.unobserve(e.target); } });
          }, { threshold: .15 });
          this.querySelectorAll('.nu-in').forEach((el) => this.inIo.observe(el));
          if (track) this.inIo.observe(track);
        }
      }

      disconnectedCallback() {
        if (this.heroIo) this.heroIo.disconnect();
        if (this.inIo) this.inIo.disconnect();
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.syncVideos);
        document.documentElement.style.overflow = '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
